import moment from "moment"
import { GeometryData } from "@/models/apidatamodel"
import { store } from '@/store/store'

export interface BittimittariBase {
    id: number;
    julkaisuaika: string;
    kuntanumero: string;
    maakuntanumero: string;
    nimi: string;
    namn: string;
    geoms: GeometryData;
}

export interface Liikenneonnettomuudet extends BittimittariBase{
    lukumaarakuolleetedellinen: number;
    lukumaarakuolleet: number;
    lukumaaraloukkaantuneetedellinen: number;
    lukumaaraloukkaantuneet: number;
}

export class ConvertBittimittariBase {
    public static toBittimittariBase(json: string): BittimittariBase[] {
        return JSON.parse(json)
    }

    public static bittimittariBaseToJson(value: BittimittariBase[]): string {
        return JSON.stringify(value)
    }
}

export interface LiikenteenTilastoData extends BittimittariBase {
    lukumaara: number;
    lukumaaraedellinen: number;
    erotus: number;
    erotusprosentuaalinen: number;
    suhteellinen: number;
    kayttovoima: string;
    kayttovoimakielitermi: string;
}

export interface LiikenteenTilastot extends BittimittariBase {
    lukumaara: number;
    lukumaaraEdellinen: number;
    erotus: number;
    erotusprosentuaalinen: number;
    suhteellinen: number;
    kayttovoima: string;
    kayttovoimakielitermi: string;
    tilastot: LiikenteenTilastoData[];
}

export default class BittimittariUtils {
    public getJulkaisuVuosi(data: any) : number {
        if (data.length > 0 && data[0].julkaisuaika != null) {
            return moment(data[0].julkaisuaika).year()
        }
        return 0
    }

    public getLegendColor(value: number, limits: number[]): string {
        // kunnalla/maakunnalla ei ole dataa mikäli parametrin 'value' arvo === -1
        if (value === -1 || value === null) {
            return ""
        }
        if (value < limits[0]) {
            return "#e2e2e2"
        }
        else if (value >= limits[0] && value <= limits[1]) {
            return "#bfb3b9"
        }
        else if (value > limits[1] && value <= limits[2]) {
            return "#d5a0c1"
        }
        else if (value > limits[2] && value <= limits[3]) {
            return "#da73a9"
        }
        else if (value > limits[3] && value <= limits[4]) {
            return "#dd348e"
        }
        else if (value > limits[4] && value <= limits[5]) {
            return "#b32f75"
        }
        else if (value > limits[5]) {
            return "#8d1957"
        }

        return ""
    }

    public getOperaattoriUploadLegendColor(value: number, limits: number[]): string {
        // kunnalla/maakunnalla ei ole dataa mikäli parametrin 'value' arvo === -1
        if (value === -1 || value === null) {
            return ""
        }
        if (value < limits[0]) {
            return "#e2e2e2"
        }
        else if (value >= limits[0] && value <= limits[1]) {
            return "#bfb3b9"
        }
        else if (value > limits[1] && value <= limits[2]) {
            return "#d5a0c1"
        }
        else if (value > limits[2] && value <= limits[3]) {
            return "#da73a9"
        }
        else if (value > limits[3] && value <= limits[4]) {
            return "#dd348e"
        }
        else if (value > limits[4]) {
            return "#b32f75"
        }

        return ""
    }

    /** Haetaan valitun kielen mukaan oikea nimi */
    public getName(value: BittimittariBase) {
        let newName: string = ""

        switch (this.currentLanguage) {
            case "fi":
                newName = value.nimi ?? "-"
                break
            case "sv":
                newName = value.namn ?? "-"
                break
            case "en":
                newName = value.nimi ?? "-"
                break
            default:
                newName = value.nimi ?? "-"
                break
        }

        return newName
    }

    /** Haetaan valitun kielen mukaan oikea linkki */
    public getUrl(value) {
        let newUrl: string = ""

        switch (this.currentLanguage) {
            case "fi":
                newUrl = value.urlfi ?? "#"
                break
            case "sv":
                newUrl = value.urlsv ?? "#"
                break
            case "en":
                newUrl = value.urlen ?? "#"
                break
            default:
                newUrl = value.urlfi ?? "#"
                break
        }

        return newUrl
    }

    /** Haetaan valitun kielen mukaan oikea info teksti ja splitataan se pisteen kohdalta jotta saadaa esitettyä tiedot listamuodossa */
    public getInfoText(value) {
        // infoteksti on rivitettävä
        let newInfotext: string[] = []

        switch (this.currentLanguage) {
            case "fi":
                newInfotext = value.info?.split(".") ?? []
                break
            case "sv":
                newInfotext = value.infosv?.split(".") ?? []
                break
            case "en":
                newInfotext = value.infoen?.split(".") ?? []
                break
            default:
                newInfotext = value.info?.split(".") ?? []
                break
        }

        // poistetaan mahdolliset tyhjät arvot
        const filtered = newInfotext.filter(function (el) {
            return el !== ""
        })

        return filtered
    }

    public get currentLanguage() {
        return store.getters.activeLang
    }
}
